import styled from 'styled-components'


export const ShortcutContainer= styled.div`
    margin-top: 1rem;
    
    .shortcut-link {
        
        width: 120px;
    
        background: #f9f9f9;
        border: 1px solid #f1f1f1;
        border-radius: 10px;
        padding: 1rem;
        transition: all 0.5s ease;
        box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.13);

        
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content-center;
        
        span {
            font-size: 14px;
            line-height: 1rem;
            text-align: center;
        }
        
        :hover {
            background: #f1f1f1;
        }
        
    }
   
`